import { watch, ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useViewManagerStore } from '@/common/stores/view-manager';
import type { ViewportOption, ViewportType } from './baseViewport.types';
import { VIEWPORT_OPTIONS, VIEWPORT_TYPE, VIEWPORT_CLASS_NAME } from './baseViewport.define';

const DEFAULT_TYPE = VIEWPORT_TYPE.ERROR;

export const setup = () => {
  const route = useRoute();

  const { isPageLoading } = storeToRefs(useViewManagerStore());

  const viewportOption = ref<ViewportOption>(VIEWPORT_OPTIONS[DEFAULT_TYPE]);
  const viewportClassName = ref<string>(VIEWPORT_CLASS_NAME[DEFAULT_TYPE]);
  const currentViewportType = ref<ViewportType>(DEFAULT_TYPE);
  const isAnalysisViewport = computed<boolean>(() => {
    return (
      currentViewportType.value === VIEWPORT_TYPE.PA ||
      currentViewportType.value === VIEWPORT_TYPE.PA_HEADER_TIME
    );
  });

  const isBrowserPopup = computed<boolean>(() => {
    return route.path.includes('/popup') || route.query.isBrowserPopup === 'true';
  });

  const setClassName = (type: ViewportType) => {
    if (type === VIEWPORT_TYPE.SETTING) {
      document.body.classList.add('no-min-width');
    } else {
      document.body.classList.remove('no-min-width');
    }

    viewportClassName.value = VIEWPORT_CLASS_NAME[type] ?? VIEWPORT_CLASS_NAME[DEFAULT_TYPE];
  };

  watch(
    () => route.meta.viewport,
    (type) => {
      const viewportType = type as ViewportType;

      currentViewportType.value = viewportType;
      viewportOption.value = VIEWPORT_OPTIONS[viewportType] ?? VIEWPORT_OPTIONS[DEFAULT_TYPE];
      setClassName(viewportType);
    },
    { immediate: true },
  );

  return {
    isLoading: isPageLoading,
    viewportOption,
    viewportClassName,
    currentViewportType,
    isAnalysisViewport,
    isBrowserPopup,
  };
};
